<template>
    <el-menu router class="container-menu" ref="menu"
        :collapse="collapse"
        :default-openeds="defaultOpeneds"
        :default-active="activeMenu">
        <template>
            <router-link class="site" to="/" tag="li" style="cursor: pointer">
                <!-- <i class="fab fa-bandcamp menu-icon" ></i> -->
                <img
                    src="../../assets/images/logo.svg"
                    class="container-menu-logo"
                    aria-hidden="true">
                <span class="title">{{ $store.state.site_title }}</span>
            </router-link>
        </template>
        <template v-for="(route) in menus">
            <template v-if="route.children && route.name !== 'Store'">
                <el-submenu :index="route.name" :key="route.name" >
                    <template slot="title">
                        <i :class="route.meta.ico || 'fa fa-list-ul'" aria-hidden="true"></i>
                        <span>{{route.meta.title}}</span>
                    </template>
                    <el-menu-item v-for="(cRoute, cIndex) in route.children"
                        :key="cIndex"
                        :index="cRoute.name"
                        :route="cRoute">
                        <span slot="title">{{cRoute.meta.title}}</span>
                    </el-menu-item>
                </el-submenu>
            </template>
            <template v-if="!route.children && route.name !== 'Store' ">
                <el-menu-item :index="route.name" :key="route.name" :route="route">
                    <i class="menu-icon" :class="route.meta.ico || 'fa fa-list-ul'" aria-hidden="true"></i>
                    <span slot="title">{{route.meta.title}}</span>
                </el-menu-item>
            </template>
        </template>
        <div
            @click="changeCollapse"
            :class="collapse ? '' : 'collapse-open'"
            class="fixed collapse-style flex justify-between"
            style="color: #fff;bottom: 0;">
            <el-button type="text">
                <i
                    class="fa iconfont"
                    :class="collapse ? ' icon-fitness-jiantouyou' : 'icon-fitness-jiantou3'"
                    aria-hidden="true">
                </i>
            </el-button>
        </div>
    </el-menu>
</template>

<script>
import { MenuItem, Menu, Submenu } from 'element-ui';
import { mapState } from 'vuex';
import RouterMenusFilter from '../../RouterMenusFilter';

export default {
    components: {
        ElMenu: Menu,
        ElMenuItem: MenuItem,
        ElSubmenu: Submenu,
    },
    props: ['collapse'],
    data() {
        return {
            activeMenu: '',
            defaultOpeneds: [],
        };
    },
    computed: {
        ...mapState([
            'my',
        ]),
        menus() {
            return (new RouterMenusFilter(this.my, this.$router.options.routes)).menus();
        },
    },
    watch: {
        '$route.matched'() {
            this.setActiveMenu();
        },
    },
    methods: {
        setActiveMenu() {
            const matched = this.$route.matched.filter(i => i.meta && i.meta.title);
            if (matched.length) {
                this.activeMenu = matched[matched.length - 1].name;
                return;
            }
            this.activeMenu = this.$route.name;
        },
        changeCollapse() {
            this.$store.commit('setCollapse', !this.collapse);
            this.$emit('update:collapse', !this.collapse);
        },
    },
    created() {
        this.setActiveMenu();
    },
};
</script>

<style lang="scss">
    .container-menu {
        flex-grow: 0;
        flex-shrink: 0;
        border-right: 0;
        background-color: #001529 !important;
        overflow-y: auto;
        min-height: 100vh;
        position: sticky;
        top: 0;
        z-index: 1;

        .site {
            height: 60px;
            line-height: 60px;
            padding-left: 8px;
            transition: all .3s;
            background: #002140;
            overflow: hidden;
            white-space: nowrap;
            color: #fff;
            // font-size: 20px;
            font-size: 17px;
            font-weight: bold;
            position: sticky;
            top: 0;
            z-index: 1;
        }

        &.el-menu--collapse {
            .site .title {
                opacity: 0;
            }

            .el-submenu .el-menu-item {
                background: #001529;
            }
        }

        &:not(.el-menu--collapse) {
            width: 256px;
        }

        .el-menu, .el-footer {
            background-color: transparent;
        }

        .el-submenu {
            &__title {
                &, & i{
                    color: rgba(255, 255, 255, 0.65);

                    &:hover, &:hover i {
                        color: #fff;
                        background-color: transparent;
                    }
                }
            }

            &.is-active {
                .el-submenu__title {
                    &, & i{
                        color: #fff;
                    }
                }
            }
        }

        .el-menu-item {
            color: rgba(255, 255, 255, 0.65);

            &:hover,&:hover i, &:focus {
                color: #fff;
                background-color: transparent;
            }
            &.is-active {
                color: #fff;
                background-color: #1890ff;
            }
        }

        .el-menu-item, .el-submenu__title {
            height: 45px;
            line-height: 45px;
        }

        .collapse-style {
            padding: 10px 0 10px 20px;
            width: 63px;

            &.collapse-open {
                width: 256px;
            }
        }
        .menu-icon {
            font-size: 20px;
            font-weight: 500;
            padding-right: 6px;
        }
        .container-menu-logo {
            width: 43px;
            height: 34px;
        }
    }
</style>
